import React from "react";
import { useTranslation } from "react-i18next";

const UpdationModal = ({
  onClose,
  type,
  message,
  navigate,
  navigateTo,
  icon,
}) => {
  const { t } = useTranslation();  
  const handleClose = () => {
    onClose();
    if (navigateTo) {
      navigate(navigateTo);
    }
  };

  return (
    <div
      id="confirm-modal"
      className={`modal fade d-block show ${type}`}
      tabIndex="-1"
      style={{ backgroundColor: "rgba(0,0,0,0.5)"
       }}
    >
      <div className="modal-dialog modal-sm center-modal-sm modal-change-themeBg">
        <div className="modal-content p-2 ">
          <div className="modal-header pt-3 pb-1 pe-1 ps-1 border-bottom-0 justify-content-center">
            <div className="col-sm-12 text-center">
              <img
                className="mb-2"
                src={
                  icon === undefined || icon === null
                    ? type === "success"
                      ? `${process.env.PUBLIC_URL}/images/tick-mark.svg`
                      : `${process.env.PUBLIC_URL}/images/cross-icn.svg`
                    : `${process.env.PUBLIC_URL}/images/${icon}`
                }
                style={{ width: "4.375rem", height: "4.375rem" }}
                alt=""
              />
              <h5 className="modal-title" style={{ fontWeight: "600" }}>
                {message.title}
              </h5>
            </div>
          </div>
          <div className="modal-footer border-top-0 pt-1 pe-1 ps-1">
            <button
              type="button"
              className="btn btn-secondary custom-btn-lg-pd ms-0"
              style={{ width: "100%" }}
              onClick={handleClose}
            >
              {t("OK")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdationModal;
